import { Controller } from 'stimulus';
import Tagify from '@yaireo/tagify';

export default class extends Controller {
    static targets = ['tags'];

    connect() {
        new Tagify(this.tagsTarget);
    }
}